import React from 'react';
import icon404 from '../../Assets/Images/404-iocn.png';
import logo from '../../Assets/Images/missional-waypoint-logo.svg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Page404 = () => {

  const handleGoBack = () => {
    window.location.href = '/';
  };

  return (
    <div className='page-404-container'>
      <div className="inner-container">
        <img src={logo} alt="logo" className='clogo' onClick={handleGoBack}/>
        <img src={icon404} alt="error 404"  className='img404error'/>
        <p className='test'>Page not found</p>
        <p className='subtext'>Contact your leader or priest for more details.</p>
        <button className='cta-go-back' onClick={handleGoBack}><ArrowBackIcon/>Go Back</button>
      </div>
    </div>
  )
}

export default Page404